module.exports = __webpack_public_path__ + "698233be24ed0ce3921166fc90fc0dd3.png";